// src/utils/injectTheme.js
import { Colors } from "../constants/Colors";

const TOKENS = {
  "--db-bg": Colors.LIGHT_GRAY,
  "--db-surface": Colors.CARD_BACKGROUND,
  "--db-surface-alt": Colors.LIGHT_GRAY,
  "--db-border": Colors.BORDER_GRAY,
  "--db-border-strong": "#c9c9c9",
  "--db-text": Colors.TEXT_DARK,
  "--db-text-muted": Colors.TEXT_LIGHT,
  "--db-text-subtle": Colors.GRAY,
  "--db-primary": Colors.SECONDARY_BLUE,
  "--db-primary-light": Colors.LIGHT_BLUE,
  "--db-accent": Colors.PRIMARY,
  "--db-primary-soft": "rgba(14, 107, 248, 0.08)",
  "--db-success": Colors.SUCCESS,
  "--db-warning": Colors.WARNING,
  "--db-danger": Colors.RED,
  "--db-info": Colors.INFO,
  "--db-star": Colors.STAR_YELLOW,
  "--db-inactive": Colors.ICON_INACTIVE,
  "--db-status-active": Colors.STATUS_ACTIVE,
  "--db-status-busy": Colors.STATUS_BUSY,
  "--db-status-inactive": Colors.STATUS_INACTIVE,
  "--db-status-offline": Colors.STATUS_OFFLINE,
};

export function applyTheme(root = document.documentElement) {
  Object.entries(TOKENS).forEach(([k, v]) => root.style.setProperty(k, v));
}